<template>
  <div>
    <!-- 顶部Banner -->
    <img class="aam-info-banner" alt="pic" src="https://img.blendermagic.cn/new/article/ads1.jpg"/>
    <!-- 标题 -->
    <div class="aam-info-title">
      <h1 class="aam-info-title main-title">{{ metaData.name }}</h1>
      <p>
        <span>分类：{{ metaData.classificationName }}</span>
        <span class="margin-left-25">难度：{{ metaData.lvlName }}</span>
        <span class="margin-left-25">开源：{{ metaData.openSource ? '是' : '否' }}</span>
        <span class="margin-left-25">发布时间：{{
            new Date(metaData.createTime).toLocaleDateString().replace(/\//g, '-')
          }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleTitle",
  props: {
    metaData: Object,
  }
}
</script>